import type { ReactNode } from "react";

type ChartPanelProps = {
  title: string;
  subtitle?: string;
  children: ReactNode;
  className?: string;
  actions?: ReactNode;
};

/** Consistent wrapper for Recharts and analytics blocks. */
export function ChartPanel({
  title,
  subtitle,
  children,
  className = "",
  actions,
}: ChartPanelProps) {
  return (
    <div className={`sh-panel flex flex-col overflow-hidden p-4 ${className}`}>
      <div className="mb-3 flex items-start justify-between gap-2">
        <div>
          <h3 className="sh-section-title">{title}</h3>
          {subtitle ? <p className="sh-subtle mt-0.5">{subtitle}</p> : null}
        </div>
        {actions}
      </div>
      <div className="min-h-0 flex-1">{children}</div>
    </div>
  );
}
